import React from "react";
import {
  Box,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ErrorOutline,
  History,
} from "@mui/icons-material";
import { formatDateWithTime } from "../../helpers";
import { IAcitvityHistoryLogsProps } from "./Activity.types";
import { useDispatchWrapper } from "../../hooks";
import { fetchHistoryByTableColumnAsync } from "../../redux/common/commonActions";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { IGeneralHistory } from "../../redux/common/common.types";
import { ERROR_MESSAGES, LoadState } from "../../constants/enums";

export const ActivityHistoryLogs: React.FC<IAcitvityHistoryLogsProps> = (props) => {
  const { moduleInformation } = props;

  const { list, loading } = useSelector(
    (storeState: IStoreState) => storeState.common.generalHistory
  );

  const theme = useTheme();

  const dispatch = useDispatchWrapper();

  
  const fetchHistory = async () => {
    dispatch(fetchHistoryByTableColumnAsync(moduleInformation.moduleId));
  };

  React.useEffect(() => {
    fetchHistory();
  }, []);



  return (
    <>
      <Stack mt={3}>
        <Stack
          padding={1}
          sx={{
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
          }}
        >
          <Typography variant="h5" fontWeight={600}>
            Logs
          </Typography>
        </Stack>
        <Stack direction={"column"} spacing={1} mt={3}>
          {loading === LoadState.InProgress && (
            <>
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
            </>
          )}
           {loading === LoadState.Loaded && list.length === 0 && (
              <>
              <Box minHeight={100} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
               <Box display={'flex'} justifyContent={'center'} mb={1}>
                 <ErrorOutline/>
               </Box>
             <Box display={'flex'} justifyContent={'center'} width={'80%'}>
             <Typography variant="body1" textAlign={'center'} fontWeight={600}>{ERROR_MESSAGES.NO_RECORD_FOUND}</Typography>
             </Box>
              </Box>
           </>
          )}

          {list.map((item, index) => {
            return <Row key={index} data={item} />;
          })}
        </Stack>
      </Stack>
    </>
  );
};

const Row: React.FC<{ data: IGeneralHistory }> = ({ data }) => {
  const theme = useTheme();

  return (
    <Stack position="relative" minHeight="80px">
      <Stack
        direction="row"
        spacing={1.5}
        sx={{
          ":before": {
            content: "''",
            height: "100%",
            width: "2px",
            position: "absolute",
            left: "18px", // <-- fixed position for vertical line
            top: 0,
            bottom: 0,
            zIndex: 0,
            backgroundColor: theme.palette.warning.main,
          },
        }}
      >
        <Box
          border="1px solid #fff"
          sx={{ backgroundColor: "#fff" }}
          zIndex={1}
          height="fit-content"
        >
          <History color="warning" fontSize="large" />
        </Box>
        <Stack width="100%">
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="body1"
              fontSize="1.1rem"
              maxWidth="55%"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              fontWeight={600}
            >
              {data.created_by_name}
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formatDateWithTime(data.insert_ts)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body1" fontWeight={500}>
              {data.message}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
